/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import Trendup from "../../assets/logos/Trendup.svg";
import Trenddown from "../../assets/logos/TrendDown.svg";

const DOCUMENT_AGENT_STATIC_METRICS = [
  {
    title: "Documents Processed",
    value: "1,248",
    hint: "Total documents processed",
    label: "Last 30 days",
    iconKey: "documents",
  },
  {
    title: "Avg Processing Time",
    value: "2.4s",
    hint: "Average time per document",
    label: "System average",
    iconKey: "clock",
  },
  {
    title: "Success Rate",
    value: "98.7%",
    hint: "Successful document extraction",
    label: "Quality score",
    iconKey: "success",
  },
  {
    title: "Errors Detected",
    value: "16",
    hint: "Documents with errors",
    label: "Needs review",
    iconKey: "warning",
  },
];

const MOCK_DOCUMENT_AGENT_METRICS = {
  current_quarter: {
    average_error_rate: 0.33,
    average_processing_time: "41.67s",
    average_document_quality_score: 59.33,
  },
  previous_quarter: {
    average_error_rate: 0.5,
    average_processing_time: "41.5s",
    average_document_quality_score: 44,
  },
  comparison: {
    error_rate_change: 34,
    error_rate_trend: "declined",
    processing_time_change: 0.41,
    processing_time_trend: "improved",
    quality_score_change: 34.84,
    quality_score_trend: "improved",
  },
};

export const AGENT_METRICS = {
  "review-intake-a1": {
    api: '/intake-review-metrics',
    mapResponse: (apiResponse) => {
      if (!apiResponse?.today_activity) return [];

      const { today_activity, total_activity } = apiResponse;

      return [
        {
          iconKey: "potentialDuplicatesToday",
          value: total_activity.total_potential_duplicates,
          hint: today_activity.potential_duplicates_pct,
          label: "+8% detection accuracy from last week",
        },
        {
          iconKey: "applicationsReviewedToday",
          value: total_activity.total_records_checked,
          hint: today_activity.records_checked_today,
          label: "+4 applications per day from last week",
        },
      ];
    },
  },

  DocumentProcessingAgent: {
    api: '/document_quality_metrics',

    mapResponse: (apiResponse) => {
      if (!apiResponse?.current_quarter || !apiResponse?.comparison) return [];

      const { current_quarter, comparison, previous_quarter } = apiResponse;

      const trendIcon = (trend) => (trend === "improved" ? Trendup : Trenddown);
      const trendArrow = (trend) => (trend === "improved" ? "▲" : "▼");

      const trendLabel = (trend, change) => `${trendArrow(trend)} ${change}% ${
        trend === "improved"
          ? "Up from last quarter"
          : "Down from last quarter"
      }`;

      return [
        {
          iconKey: "documents",
          value: current_quarter.average_document_quality_score?.toFixed(2),
          hint: previous_quarter?.average_document_quality_score,
          label: trendLabel(
            comparison.quality_score_trend,
            comparison.quality_score_change,
          ),
          labelIcon: trendIcon(comparison.quality_score_trend),
        },
        {
          iconKey: "warning",
          value: `${(current_quarter.average_error_rate * 100).toFixed(0)}%`,
          hint: `${(previous_quarter.average_error_rate * 100).toFixed(0)}%`,
          label: trendLabel(
            comparison.error_rate_trend,
            comparison.error_rate_change,
          ),
          labelIcon: trendIcon(comparison.error_rate_trend),
        },
        {
          iconKey: "clock",
          value: current_quarter.average_processing_time,
          hint: previous_quarter?.average_processing_time,
          label: trendLabel(
            comparison.processing_time_trend,
            comparison.processing_time_change,
          ),
          labelIcon: trendIcon(comparison.processing_time_trend),
        },
      ];
    },
  },

  // "benefit-agent-b1": { api: "...", mapResponse: (...) => [...] },
  "eligibility-review-agent": {
    type: "static",
    data: [
      {
        iconKey: "documents",
        title: "Quality of Applications",
        value: "63%",
        hint: "Acceptable",
        label: "4.3% Down from last quarter",
      },
      {
        iconKey: "warning",
        title: "Fraudulent Applications",
        value: "2%",
        hint: "",
        label: "1% from last week",
      },
      {
        iconKey: "clock",
        title: "Application Processing Time",
        value: "43s",
        hint: "",
        label: "8 seconds faster in the last 5 days",
      },
    ],
  },
};
